module.exports = __webpack_public_path__ + "img/about.a164748a.jpg";